import { render } from "./colorSelect.vue?vue&type=template&id=255a8e20"
import script from "./colorSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./colorSelect.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/AlbbPublishProduct/components/colorSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "255a8e20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('255a8e20', __exports__)) {
    api.reload('255a8e20', __exports__)
  }
  
  module.hot.accept("./colorSelect.vue?vue&type=template&id=255a8e20", () => {
    api.rerender('255a8e20', render)
  })

}


export default __exports__